import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.path
      ? { '@id': `https://www.mogumovie.com${item.path}`, name: item.label }
      : { '@id': 'https://www.mogumovie.com/', name: item.label },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-400 overflow-x-auto whitespace-nowrap py-2">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </div>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-primary-400 transition-colors duration-200 cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-200">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}